import React, { useState } from "react";
import { IoMenu } from "react-icons/io5";
import { FaSearch } from "react-icons/fa";
import { MdQrCodeScanner } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import "./Header.css";
import { Link, useLocation } from "react-router-dom";
import Menu from "./Menu.jsx";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const [menuOpen, setOpenMenu] = useState(false);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/admin");

  const handleSearch = (e) => {
    if (e.key === "Enter" && search.trim() !== "") {
      navigate(`/search/${search}`);
      setSearch("");
    }
  };
  return (
    <>
      <header>
        <aside className="head-first">
          <Link to="/">
            <h3>Chaitany Flowers</h3>
          </Link>
          <div className="menu-icon">
            <IoMenu
              className="menu"
              onClick={() => {
                setOpenMenu(!menuOpen);
              }}
            />
            
          </div>
        </aside>
        <aside className="head-second">
          <div className="search-bar">
            <FaSearch className="search-icon" />
            <input
              type="text"
              name="search"
              id="search"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={handleSearch}
            />
          </div>
          <MdQrCodeScanner className="scanner" />
        </aside>
        <aside className="head-third">
          <Link to="/cart">
            <FaShoppingCart className="cart" />
          </Link>
          <div
            className="user"
            onClick={() => {
              setOpenMenu(!menuOpen);
            }}
          >
            {" "}
            
          </div>
        </aside>
      </header>
      <Menu isOpen={menuOpen} setIsOpen={setOpenMenu} />

      {!isAdminPage && (
        <aside className="category-menu">
          <Link to="/category/all" className="category all">
            All
          </Link>
          <Link to="/category/garland" className="category garland">
            Garland
          </Link>
          <Link to="/category/bouquet" className="category bouquet">
            Bouquet
          </Link>
          <Link
            to="/category/weddingGarland"
            className="category weddingGarland"
          >
            Wedding Garland
          </Link>
          <Link to="/category/carGarland" className="category carGarland">
            Car Garland
          </Link>
          <Link to="/category/carDecoration" className="category carDecoration">
            Car Decoration
          </Link>
          <Link
            to="/category/flowerAccessories"
            className="category flowerAccessories"
          >
            Flower Accessories
          </Link>
        </aside>
      )}
    </>
  );
}
